import { defineStore } from "pinia";
import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";

interface State {
	pageTitle: string;
	pageType: string;
	categoryBreadcrumb: BreadcrumbsCategory | null;
}

export const usePageStore = defineStore("pageStore", {
	state: (): State => ({
		pageTitle: "",
		pageType: "", // cms, home, category, product, cart, checkout
		categoryBreadcrumb: null
	}),
	actions: {
		setPageTitle(page: string) {
			this.pageTitle = page;
		},
		setPageType(type: string) {
			this.pageType = type;
		},
		setCategoryBreadcrumb(category: BreadcrumbsCategory) {
			this.categoryBreadcrumb = category;
		}
	}
});
